import r from "./ghl-ui.es1506.js";
import g from "./ghl-ui.es1466.js";
function i(a, o) {
  g(2, arguments);
  var t = r(a), e = r(o);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
export {
  i as default
};
